import React from "react";
import PublicPageFrame from "./PublicPageFrame";
import { useLanguage } from "../contexts/LanguageContext";
import { getPublicPageCopy } from "../data/publicPagesCopy";

const PrivacyPolicyPage: React.FC = () => {
  const { language, t } = useLanguage();
  const copy = getPublicPageCopy(language).privacy;

  return (
    <PublicPageFrame
      title={copy.title}
      seoTitle={copy.seoTitle}
      seoDescription={copy.seoDescription}
      updatedAtLabel={copy.updatedAtLabel}
      updatedAt={copy.updatedAt}
      homeLabel={t("publicBackToSite")}
      homeHref="/"
      footerLinks={copy.footerLinks}
    >
      {copy.intro?.map((paragraph, index) => (
        <React.Fragment key={`intro-${index}`}>{paragraph}</React.Fragment>
      ))}

      <div className="mt-10 space-y-10">
        {copy.sections.map((section) => (
          <section key={section.title}>
            <h2 className="text-lg font-semibold tracking-tight text-white">
              {section.title}
            </h2>
            <div className="mt-3 space-y-3 text-base leading-7 text-slate-300">
              {section.body}
            </div>
          </section>
        ))}
      </div>
    </PublicPageFrame>
  );
};

export default PrivacyPolicyPage;
